import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapState } = createNamespacedHelpers("global");

export default {
  data() {
    return {
      is_show_popup_for_old_user: false,
    };
  },

  computed: {
    ...mapState(["user"]),
    ...mapGetters(["isUserInProject"]),

    hasRegisteredHere() {
      return (
        this.isUserInProject &&
        !!this.user.fields["registration_url"] &&
        this.user.fields["registration_url"].indexOf(this.promo_name) > -1
      );
    },

    countDaysFromLastLogin() {
      if (!this.user.last_login_at) return null;

      let now = new Date();
      let login_date = new Date(this.user.last_login_at);

      let result = Math.floor((now - login_date) / (1000 * 60 * 60 * 24));

      return result;
    },
  },

  methods: {
    showPopupForOldUser() {
      this.is_show_popup_for_old_user = true;
    },

    closePopupForOldUser() {
      this.is_show_popup_for_old_user = false;
    },
  },
};
